export default {
    approved: "Approved",
    conditional_approved: "Conditional approved",
    unfinalise: "We are currently working on amends to the final claim pack, once complete, you will be able to review and approve.",
    pending_review: "We are currently preparing your R&D claim, once complete you will be able to review and approve.",
    not_reviewed: "We are currently preparing your R&D claim, once complete you will be able to review and approve."
}
